<template>
    <aside class="catalog-layout__sidebar">
        <button class="not-big catalog-layout__sidebar_trigger" id="showHideFilters"><span>Фильтры<span class="count" v-if="Object.keys($parent.cleanFilters) && Object.keys($parent.cleanFilters).length > 0">{{Object.keys($parent.cleanFilters).length}}</span></span></button>
        <div class="catalog-layout__sidebar_container">
            <div class="catalog-layout__sidebar_content">
                <form class="form-default white-fields" @submit="submit" @reset.prevent="reset">

                    <!-- Orders -->
                    <div class="row">
                        <div class="group-title"><span>Сортировка</span></div>
                        <sort-order-dropdown v-model="$parent.orderBy"></sort-order-dropdown>
                    </div>

                    <!-- Metro -->
                    <div class="row">
                        <div class="group-title"><span>Метро</span></div>
                        <metro-dropdown v-model="filters.metro" ref="metros"></metro-dropdown>
                    </div>

                    <!-- Districts -->
                    <div class="row">
                        <div class="group-title"><span>Район</span></div>
                        <districts-dropdown v-model="filters.districts"></districts-dropdown>
                    </div>

                    <!-- Rooms -->
                    <div class="row">
                        <div class="group-title"><span>количество комнат</span></div>
                        <room-numbers-list :min="0" :max="4" v-model="filters.roomTypes"></room-numbers-list>
                    </div>

                    <!-- Price -->
                    <div class="row">
                        <div class="group-title"><span>Стоимость</span></div>
                        <label class="input-container">
                            <span class="input-container__prefix">от</span>
                            <span class="input-container__postfix"><i class="ruble"></i></span>
                            <input type="number" placeholder="1 000 000" v-model.number="filters.price.minimum">
                        </label>
                    </div>
                    <div class="row">
                        <label class="input-container">
                            <span class="input-container__prefix">до</span>
                            <span class="input-container__postfix"><i class="ruble"></i></span>
                            <input type="number" placeholder="20 000 000" v-model.number="filters.price.maximum">
                        </label>
                    </div>

                    <!-- Readiness -->
                    <div class="row m-2">
                        <div class="group-title"><span>Срок сдачи до</span></div>
                        <ending-years-list v-model="filters.readinesses"></ending-years-list>
                    </div>

                    <!-- Square -->
                    <div class="row m-va-t">
                        <div class="group-title"><span>Общая площадь</span></div>
                        <div class="col">
                            <label class="input-container">
                                <span class="input-container__prefix">от</span>
                                <span class="input-container__postfix">м<sup>2</sup></span>
                                <input type="number" placeholder="25" v-model.number="filters.square.minimum">
                            </label>
                        </div>
                        <div class="col">
                            <label class="input-container">
                                <span class="input-container__prefix">до</span>
                                <span class="input-container__postfix">м<sup>2</sup></span>
                                <input type="number" placeholder="300" v-model.number="filters.square.maximum">
                            </label>
                        </div>
                    </div>

                    <button class="button-pill filled" type="submit" @click.prevent="submit">Поиск</button>
                    <button class="button-pill lighted" type="reset" @click.prevent="reset"><i class="cross"></i>Сбросить фильтры</button>
                </form>
            </div>
        </div>
    </aside>
</template>

<script>
    // Components
    import roomNumbersList from './RoomNumbersList.vue';
    import endingYearsList from './EndingYearsList.vue';
    import sortOrderDropdown from './SortOrderDropdown.vue';
    import metroDropdown from './MetroDropdown.vue';
    import districtsDropdown from './DistrictsDropdown.vue';

    export default {
        props: ['filters'],
        methods: {
            submit() {
                this.$emit('submited', this.$route.name ? this.$route.name : 'grid');
                this.toggleMenu();
            },
            reset() {
                this.$emit('reset');
                this.toggleMenu();
            },
            toggleMenu() {             
                let btn = document.getElementById('showHideFilters');
                btn.click();
            }
        },
        components: {
            roomNumbersList,
            endingYearsList,
            sortOrderDropdown,
            metroDropdown,
            districtsDropdown
        }
    }
</script>